"use client";
import type { SMBPaginatedRequest } from "@layer/types/api";
import { useInfiniteQuery } from "@tanstack/react-query";
import {
	type GetAvailableMerchantsParams,
	getAvailableMerchants,
} from "@/api/merchant/endpoints/get-available-merchants";
import { merchantQueryKeys } from "@/api/merchant/merchant-query-keys";
import type { MerchantDTO } from "@/api/types/merchants.types";

export const useAvailableMerchants = (params: GetAvailableMerchantsParams) => {
	const { clientTenant, pageSize } = params;
	return useInfiniteQuery<SMBPaginatedRequest<MerchantDTO> | undefined>({
		queryKey: merchantQueryKeys.availableMerchantsList(
			clientTenant,
			pageSize,
		),
		queryFn: async ({ pageParam }) => {
			const { data, error } = await getAvailableMerchants({
				pagingToken: pageParam ? pageParam.toString() : undefined,
				...params,
			});

			if (error) {
				throw new Error(error);
			}

			return data;
		},
		initialPageParam: null,
		getNextPageParam: (lastPage) => lastPage?.paging.nextToken || null,
		enabled: !!clientTenant,
	});
};
